import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {PIXI} from '@colonist/pixi'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Point} from '@colonist/game-mechanic-validators'

export class UIGameMapDiceHighlightView extends SpriteView {
    private readonly originalParent: PIXI.Container
    private readonly size: number
    private readonly center: Point

    constructor(x: number, y: number, size: number, container: PIXI.Container) {
        const inactiveTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_square_yellow)
        super(x, y, size, size, container, inactiveTexture)
        this.originalParent = container

        this.size = size
        this.center = new Point(x + size / 2, y + size / 2)
    }

    hide() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
    }

    show() {
        if(this.parent != undefined) return
        this.originalParent.addChild(this)
    }

    setActiveTexture() {
        this.texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_square_white)
    }

    setInactiveTexture() {
        this.texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_square_yellow)
    }
}
